<script lang="ts">
    import { getJetPerform } from '~/jet';
    import SignInButton from '@amp/web-app-components/src/components/buttons/SignInButton/SignInButton.svelte';
    import AccountMenu from '@amp/web-app-components/src/components/AccountMenu/AccountMenu.svelte';
    import { CommerceRoute, getCommerce } from '~/utils/commerce';
    import { makeSignOutAction } from '~/actions/sign-out-action';
    import {
        CommerceModalActionOperationType,
        makeCommerceModalAction,
    } from '~/actions/commerce-modal-action';
    import { getLocale } from '~/utils/locale';
    import { getI18n } from '~/stores/i18n';
    // import { makeSettingsAction } from '~/actions/settings-action';
    // import { isPremiumSubscriber } from '~/utils/user';

    const { state: commerceState } = getCommerce();
    const i18n = getI18n();
    const locale = getLocale();

    const perform = getJetPerform();
    const handleSignOut = () => {
        perform(makeSignOutAction());
    };

    const handleSignIn = () => {
        const signInAction = makeCommerceModalAction({
            type: CommerceModalActionOperationType.Open,
            activePath: CommerceRoute.authenticate,
        });
        perform(signInAction);
    };

    const handleSettingsClick = () => {
        //     const action = makeSettingsAction(locale);
        //     perform(action);
    };

    let items = [];
</script>

<div class="auth-content" data-testid="auth-content">
    {#if $commerceState.user !== null}
        <AccountMenu
            avatarArtworkUrl={$commerceState.user?.avatarArtworkUrl}
            showSettings={false}
            on:signOut={handleSignOut}
            on:settings={handleSettingsClick}
            translateFn={$i18n.t}
            {items}
        />
    {:else if $commerceState.isSetup}
        <SignInButton translateFn={$i18n.t} on:click={handleSignIn} />
    {/if}
</div>

<style lang="scss">
    .auth-content {
        align-self: center;
    }

    :global(amp-contextual-menu) {
        --ctxmenu-z-index: var(--z-contextual-menus);
        --ctxmenu-scrim-z-index: var(--z-contextual-menus);
    }
</style>
